@if (searchService.searchError$ | async; as error) {
  <rotec-service-error-v2>
    @if (error.length) {
      <div>
        <div class="rc-mt-10" translate>Additional Information for Support</div>
        <div>{{ error }}</div>
      </div>
    }
  </rotec-service-error-v2>
} @else {
  <div class="header-row">
    <div>
      @if (userRightsService.hasActionRights$(actions.addTask) | async) {
        <button rotec-button-active bullet icon="plus" (click)="addNewTask()">
          {{ 'Add Task' | translate }}
        </button>
      }
    </div>
    <rotec-radio-row-v2
      class="company-filter-buttons"
      [options]="searchService.responsibleCompanyOptions"
      [selected]="state.responsibleCompanyFilterValue"
      [spaceEvenly]="true"
      (selectedChange)="searchService.filterForResponsible($event)"
    ></rotec-radio-row-v2>
  </div>
  <div class="task-search">
    <rotec-default-grid-v2
      [height]="gridHeight"
      [columns]="state.columns"
      [controlButtons]="controlButtons"
      (columnsChange)="updateColumnSettings($event)"
      (pageSizeChanged)="reactToPageSizeChange($event)"
      [data]="state.searchData"
      (stateChange)="refineSearch($event)"
      [selectConfig]="{
        checkboxAlwaysVisible: true,
        checkboxToggleOnWholeRow: false,
      }"
      [selectedResults]="state.searchData.selectedIds"
      (selectedResultsChange)="searchService.setSelectedResults($event)"
      (selectedItemChanged)="toggleSelectedItem($event)"
      (addEntry)="addNewTask()"
      [filterButton]="false"
      (fulltextSearchChanged)="keyupEnterSearch($event)"
      (rowClick)="openTask($event)"
      [fixedSpinner]="true"
    >
      <ng-template rotecGridCellV2="plantName" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.plantName || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="machineName" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.machineName || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="machineSerial" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.machineSerial || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="schenckId" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.schenckId || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="customerId" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.customerId || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="title" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.title || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="priority" let-dataItem="dataItem">
        <ma-priority
          class="grid-text-cell"
          [priority]="dataItem.priority"
          [isSelected]="isSelected(dataItem.id)"
        ></ma-priority>
      </ng-template>
      <ng-template rotecGridCellV2="responsibleCompany" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.responsibleCompany || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="responsible" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.responsible || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="executive" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.executive || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="dueDate" let-dataItem="dataItem">
        <ma-date
          class="grid-text-cell"
          [date]="dataItem.dueDate"
          [isSelected]="isSelected(dataItem.id)"
        ></ma-date>
      </ng-template>
      <ng-template rotecGridCellV2="status" let-dataItem="dataItem">
        <div class="grid-text-cell status-cell">
          <ma-status
            [dueDate]="dataItem.dueDate"
            [referenceDate]="dataItem.referenceDate"
            [status]="dataItem.status"
            [isSelected]="isSelected(dataItem.id)"
          ></ma-status>
        </div>
      </ng-template>
      <ng-template rotecGridCellV2="description" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.description || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="component" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.component || '-' | taskComponent }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="type" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.type | typeEnum }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="requiredTooling" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.requiredTooling || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="possibleSpareParts" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.possibleSpareParts || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="expectedDurationMinutes" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.expectedDurationMinutes || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="scheduling" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.scheduling | taskInterval }}</p>
      </ng-template>
    </rotec-default-grid-v2>
  </div>
}

<ng-template #content>
  <div class="header-row">
    <div>
      @if (userRightsService.hasActionRights$(actions.addTask) | async) {
        <button rotec-button-active bullet icon="plus" (click)="addNewTask()">
          {{ 'Add Task' | translate }}
        </button>
      }
    </div>
    <rotec-radio-row-v2
      class="company-filter-buttons"
      [options]="searchService.responsibleCompanyOptions"
      [selected]="state.responsibleCompanyFilterValue"
      [spaceEvenly]="true"
      (selectedChange)="searchService.filterForResponsible($event)"
    ></rotec-radio-row-v2>
  </div>

  <div class="task-search">
    <rotec-default-grid-v2
      [height]="gridHeight"
      [columns]="state.columns"
      [controlButtons]="controlButtons"
      (columnsChange)="updateColumnSettings($event)"
      (pageSizeChanged)="reactToPageSizeChange($event)"
      [data]="state.searchData"
      (stateChange)="refineSearch($event)"
      [selectConfig]="{
        checkboxAlwaysVisible: true,
        checkboxToggleOnWholeRow: false,
      }"
      [selectedResults]="state.searchData.selectedIds"
      (selectedResultsChange)="searchService.setSelectedResults($event)"
      (selectedItemChanged)="toggleSelectedItem($event)"
      (addEntry)="addNewTask()"
      [filterButton]="false"
      (fulltextSearchChanged)="keyupEnterSearch($event)"
      (rowClick)="openTask($event)"
      [fixedSpinner]="true"
    >
      <ng-template rotecGridCellV2="plantName" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.plantName || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="machineName" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.machineName || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="machineSerial" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.machineSerial || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="schenckId" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.schenckId || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="customerId" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.customerId || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="title" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.title || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="priority" let-dataItem="dataItem">
        <ma-priority
          class="grid-text-cell"
          [priority]="dataItem.priority"
          [isSelected]="isSelected(dataItem.id)"
        ></ma-priority>
      </ng-template>
      <ng-template rotecGridCellV2="responsibleCompany" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.responsibleCompany || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="responsible" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.responsible || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="executive" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.executive || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="dueDate" let-dataItem="dataItem">
        <ma-date
          class="grid-text-cell"
          [date]="dataItem.dueDate"
          [isSelected]="isSelected(dataItem.id)"
        ></ma-date>
      </ng-template>
      <ng-template rotecGridCellV2="status" let-dataItem="dataItem">
        <div class="grid-text-cell status-cell">
          <ma-status
            [dueDate]="dataItem.dueDate"
            [referenceDate]="dataItem.referenceDate"
            [status]="dataItem.status"
            [isSelected]="isSelected(dataItem.id)"
          ></ma-status>
        </div>
      </ng-template>
      <ng-template rotecGridCellV2="description" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.description || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="component" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.component || '-' | taskComponent }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="type" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.type | typeEnum }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="requiredTooling" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.requiredTooling || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="possibleSpareParts" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.possibleSpareParts || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="expectedDurationMinutes" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.expectedDurationMinutes || '-' }}</p>
      </ng-template>
      <ng-template rotecGridCellV2="scheduling" let-dataItem="dataItem">
        <p class="grid-text-cell">{{ dataItem.scheduling | taskInterval }}</p>
      </ng-template>
    </rotec-default-grid-v2>
  </div>
</ng-template>

<ng-template #statusFilter let-value="value" let-changeValue="changeValue">
  <ma-status-filter [value]="value" (valueChange)="changeValue($event)"></ma-status-filter>
</ng-template>
